export default __webpack_public_path__ + "static/media/image-3.5b0608a3.jpg";